import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { formatImage } from '@ifeng/public_method';
import { cookie } from '@ifeng/ui_base';
import { getHomeLocalStationData, getRecommendDataList } from '../../../../services/api';
import { newStickFeedDataHandle } from '@ifeng/three_terminal/es/utils';
import styles from './index.css';
import Module from '../../module';

class HeadLines extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        localStationData: [],
        localStationUrl: '',
        localStationName: '',
    };

    componentDidMount() {
        this.localStationInfo();
    }
    localStationInfo() {
        const provinceId = cookie.get('prov');
        const cityId = cookie.get('city');
        const { localStationData } = this.props.content;
        let isCity = false;
        let isProvince = false;

        localStationData.forEach(item => {
            if (item.number.toString() === provinceId.toString()) {
                if (item.city && item.city.length > 0) {
                    item.city.forEach(items => {
                        if (cityId.toString() === items.cityNumber) {
                            isCity = true;
                            this.getLocalStationApi(items.cityId, items.cityUrl, items.cityName, items.isCityUcms);
                        }
                    });
                } else if (item.isOpen) {
                    isProvince = true;
                    this.getLocalStationApi(item.id, item.url, item.name, item.isUcms);
                }

                if (!isCity && !isProvince && item.isOpen) {
                    this.getLocalStationApi(item.id, item.url, item.name, item.isUcms);
                }
            }
        });
    }
    async getLocalStationApi(id, url, name, isUcms) {
        let dataCb = '';

        if (isUcms) {
            dataCb = await getRecommendDataList(id, 38);
        } else {
            dataCb = await getHomeLocalStationData(id);
        }

        if (dataCb && dataCb.length > 0) {
            let localStationData = dataCb;

            if (!isUcms) {
                localStationData = this.formatData(dataCb);
            }

            this.setState({
                localStationData,
                localStationUrl: url,
                localStationId: id,
                localStationName: `${name}要闻`,
            });
        }
    }

    formatData(data) {
        const formatData =
            data &&
            data.map((item, index) => {
                let heatMarkWork = '';
                let page = 0;
                let thumbnails = '';
                const hasVideoIcon = item.dataType === 'video' ? 1 : 0;

                if (item.dataType === 'topic' || item.dataType === 'special') {
                    heatMarkWork = '专题';
                } else if (item.dataType === 'video' || item.dataType === 'phvideo') {
                    heatMarkWork = '视频';
                } else if (item.dataType === 'slide' && item.picNums) {
                    page = item.picNums;
                } else if (item.iconType) {
                    heatMarkWork = item.iconType;
                }

                if (item.i_thumbnail) {
                    thumbnails = {
                        image: [
                            {
                                bytes: 277,
                                width: 230,
                                url: formatImage(item.i_thumbnail, 230, 152),
                                height: 152,
                            },
                        ],
                    };
                }

                return {
                    id: index,
                    type: 'article',
                    title: item.title || '',
                    url: item.pageUrl || '',
                    thumbnails,
                    heatMark: heatMarkWork,
                    hasVideoIcon,
                    page,
                };
            });

        return formatData;
    }

    render() {
        const { content } = this.props;
        const { localStationData, localStationUrl, localStationName } = this.state;
        const { stickFeed, headLinesMd, headLinesAllFeedData, headLinesAd } = content;
        const normalTabsData = (headLinesMd && headLinesMd.moduleTh) || '';
        const stickFeedChipConfig = {
            id: '75028',
            type: 'recommend',
            title: '要闻区置顶数据',
            groupName: 'content',
            translate: 'handleHomeStickInfo',
        };
        const newsStreamChipConfig = {
            id: '75029',
            type: 'recommend',
            title: '要闻区数据',
            groupName: 'content',
            translate: 'handleHomeHeadLinesInfo',
        };

        if (normalTabsData) {
            normalTabsData.chipConfig = {
                id: '50172',
                type: 'struct',
                title: '要闻区子导航数据',
                groupName: 'content',
                translate: 'handleHomeHeadLinesMdInfo',
            };
        }
        normalTabsData.localStationInfo = {
            url: localStationUrl,
            name: localStationName,
            defaultWord: '切换城市',
            switchWord: '返回要闻',
        };

        const newStickFeedData = newStickFeedDataHandle(stickFeed);

        const moduleData = {
            normalTabsData,
            feedAd: headLinesAd,
            stickFeedChipConfig,
            stickFeed: newStickFeedData,
            newsStreamChipConfig,
            newsStreamData: headLinesAllFeedData,
            localStationData,
            showNum: 18,
            stepNum: 10,
            countNum: 52,
        };

        return (
            <section className={styles.headLines}>
                {moduleData.newsStreamData && <Module content={moduleData} />}
            </section>
        );
    }
}

export default errorBoundary(HeadLines);
